import { render, staticRenderFns } from "./singleProfile.vue?vue&type=template&id=3d89afae&scoped=true&"
import script from "./singleProfile.vue?vue&type=script&lang=js&"
export * from "./singleProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89afae",
  null
  
)

export default component.exports